// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const additionalRepair = claim =>
    dispatch => {

        dispatch({
            data: claim,
            type: actions.ADD_CLAIM_PIP_ADDITIONAL_REPAIR
        });

        dispatch(routerActions.push('/claims/pip/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/additional-repair.js